import { Twitter, Facebook, MailOutline} from '@material-ui/icons';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useContext, MouseEvent } from 'react'
import { Context } from '../../context/Context';
import Avatar from '../../assets/images/avatar.jpg'
import '../../assets/css/MainNav.css';


const MainNav = () => {
  const PF = "https://heroblog-api.onrender.com/images/"
  let { user, dispatch} = useContext(Context);

  // if (user) {
  //   const {username, bio, email, profilePic} = user;
  // } 

  // console.log(user.profilePic);
 
  const handleLogout = (e: MouseEvent<HTMLElement>) => {
    // debugger;
    e.preventDefault();
    dispatch({type:"LOG_OUT"});
    window.location.replace('/');
  }

  return (
    <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
      <Container>
        <Navbar.Brand href="/">Hero</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/posts">Blog Posts</Nav.Link>
            {user && <Nav.Link href="/user"> Author</Nav.Link>}
            <Nav.Link href="/login">Login</Nav.Link>
            <Nav.Link href="/register">Register</Nav.Link>
           {user && <Nav.Link onClick={handleLogout}>
               Logout
            </Nav.Link>}
          </Nav>
          <Nav>
            <Nav.Link href="#">
              <Twitter />
            </Nav.Link>
            <Nav.Link href="#">
              <Facebook />
            </Nav.Link>
            <Nav.Link href="#">
              <MailOutline />
            </Nav.Link>
            {user &&
            <Nav.Link href="/settings">
              {user?.profilePic !=="" ? <img src={PF + user?.profilePic} width="25" height="25"  alt=""/> : <img src={Avatar} width="25" height="25" alt="" />}
            </Nav.Link>}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default MainNav
